import { render, staticRenderFns } from "./NetworkInfo.vue?vue&type=template&id=2354d338"
import script from "./NetworkInfo.vue?vue&type=script&lang=js"
export * from "./NetworkInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports